export default "__VITE_ASSET__CQOAHgMJ__"